module.exports = __webpack_public_path__ + "static/media/icon-close.7f3cfa4c.svg";